import {
    enElfPrefixes, enElfSuffixes, enMagicPrefixes, enMagicSuffixes, enDragonPrefixes, enDragonSuffixes,
    trElfPrefixes, trElfSuffixes, trMagicPrefixes, trMagicSuffixes, trDragonPrefixes, trDragonSuffixes,
    esElfPrefixes, esElfSuffixes, esMagicPrefixes, esMagicSuffixes, esDragonPrefixes, esDragonSuffixes,
    frElfPrefixes, frElfSuffixes, frMagicPrefixes, frMagicSuffixes, frDragonPrefixes, frDragonSuffixes,
    deElfPrefixes, deElfSuffixes, deMagicPrefixes, deMagicSuffixes, deDragonPrefixes, deDragonSuffixes,
    ptElfPrefixes, ptElfSuffixes, ptMagicPrefixes, ptMagicSuffixes, ptDragonPrefixes, ptDragonSuffixes,
    arElfPrefixes, arElfSuffixes, arMagicPrefixes, arMagicSuffixes, arDragonPrefixes, arDragonSuffixes,
    hiElfPrefixes, hiElfSuffixes, hiMagicPrefixes, hiMagicSuffixes, hiDragonPrefixes, hiDragonSuffixes,
    jaElfPrefixes, jaElfSuffixes, jaMagicPrefixes, jaMagicSuffixes, jaDragonPrefixes, jaDragonSuffixes,
    koElfPrefixes, koElfSuffixes, koMagicPrefixes, koMagicSuffixes, koDragonPrefixes, koDragonSuffixes,
    idElfPrefixes, idElfSuffixes, idMagicPrefixes, idMagicSuffixes, idDragonPrefixes, idDragonSuffixes,
    viElfPrefixes, viElfSuffixes, viMagicPrefixes, viMagicSuffixes, viDragonPrefixes, viDragonSuffixes,
    ruElfPrefixes, ruElfSuffixes, ruMagicPrefixes, ruMagicSuffixes, ruDragonPrefixes, ruDragonSuffixes,
    itElfPrefixes, itElfSuffixes, itMagicPrefixes, itMagicSuffixes, itDragonPrefixes, itDragonSuffixes,
    plElfPrefixes, plElfSuffixes, plMagicPrefixes, plMagicSuffixes, plDragonPrefixes, plDragonSuffixes,
    nlElfPrefixes, nlElfSuffixes, nlMagicPrefixes, nlMagicSuffixes, nlDragonPrefixes, nlDragonSuffixes,
} from '@/constants/fantasyNames/index';

export type SupportedLocale = 'en' | 'tr' | 'es' | 'fr' | 'de' | 'pt' | 'ar' | 'hi' | 'ja' | 'ko' | 'id' | 'vi' | 'ru' | 'it' | 'pl' | 'nl';

export interface FantasyNameGeneratorOptions {
    count?: number;
    style?: 'elf' | 'magic' | 'dragon' | 'any';
    locale?: SupportedLocale;
}

interface FantasyNameData {
    elfPrefixes: string[];
    elfSuffixes: string[];
    magicPrefixes: string[];
    magicSuffixes: string[];
    dragonPrefixes: string[];
    dragonSuffixes: string[];
}

const getFantasyNameData = (locale: SupportedLocale = 'en'): FantasyNameData => {
    switch (locale) {
        case 'tr':
            return {
                elfPrefixes: trElfPrefixes,
                elfSuffixes: trElfSuffixes,
                magicPrefixes: trMagicPrefixes,
                magicSuffixes: trMagicSuffixes,
                dragonPrefixes: trDragonPrefixes,
                dragonSuffixes: trDragonSuffixes,
            };
        case 'es':
            return {
                elfPrefixes: esElfPrefixes,
                elfSuffixes: esElfSuffixes,
                magicPrefixes: esMagicPrefixes,
                magicSuffixes: esMagicSuffixes,
                dragonPrefixes: esDragonPrefixes,
                dragonSuffixes: esDragonSuffixes,
            };
        case 'fr':
            return {
                elfPrefixes: frElfPrefixes,
                elfSuffixes: frElfSuffixes,
                magicPrefixes: frMagicPrefixes,
                magicSuffixes: frMagicSuffixes,
                dragonPrefixes: frDragonPrefixes,
                dragonSuffixes: frDragonSuffixes,
            };
        case 'de':
            return {
                elfPrefixes: deElfPrefixes,
                elfSuffixes: deElfSuffixes,
                magicPrefixes: deMagicPrefixes,
                magicSuffixes: deMagicSuffixes,
                dragonPrefixes: deDragonPrefixes,
                dragonSuffixes: deDragonSuffixes,
            };
        case 'pt':
            return {
                elfPrefixes: ptElfPrefixes,
                elfSuffixes: ptElfSuffixes,
                magicPrefixes: ptMagicPrefixes,
                magicSuffixes: ptMagicSuffixes,
                dragonPrefixes: ptDragonPrefixes,
                dragonSuffixes: ptDragonSuffixes,
            };
        case 'ar':
            return {
                elfPrefixes: arElfPrefixes,
                elfSuffixes: arElfSuffixes,
                magicPrefixes: arMagicPrefixes,
                magicSuffixes: arMagicSuffixes,
                dragonPrefixes: arDragonPrefixes,
                dragonSuffixes: arDragonSuffixes,
            };
        case 'hi':
            return {
                elfPrefixes: hiElfPrefixes,
                elfSuffixes: hiElfSuffixes,
                magicPrefixes: hiMagicPrefixes,
                magicSuffixes: hiMagicSuffixes,
                dragonPrefixes: hiDragonPrefixes,
                dragonSuffixes: hiDragonSuffixes,
            };
        case 'ja':
            return {
                elfPrefixes: jaElfPrefixes,
                elfSuffixes: jaElfSuffixes,
                magicPrefixes: jaMagicPrefixes,
                magicSuffixes: jaMagicSuffixes,
                dragonPrefixes: jaDragonPrefixes,
                dragonSuffixes: jaDragonSuffixes,
            };
        case 'ko':
            return {
                elfPrefixes: koElfPrefixes,
                elfSuffixes: koElfSuffixes,
                magicPrefixes: koMagicPrefixes,
                magicSuffixes: koMagicSuffixes,
                dragonPrefixes: koDragonPrefixes,
                dragonSuffixes: koDragonSuffixes,
            };
        case 'id':
            return {
                elfPrefixes: idElfPrefixes,
                elfSuffixes: idElfSuffixes,
                magicPrefixes: idMagicPrefixes,
                magicSuffixes: idMagicSuffixes,
                dragonPrefixes: idDragonPrefixes,
                dragonSuffixes: idDragonSuffixes,
            };
        case 'vi':
            return {
                elfPrefixes: viElfPrefixes,
                elfSuffixes: viElfSuffixes,
                magicPrefixes: viMagicPrefixes,
                magicSuffixes: viMagicSuffixes,
                dragonPrefixes: viDragonPrefixes,
                dragonSuffixes: viDragonSuffixes,
            };
        case 'ru':
            return {
                elfPrefixes: ruElfPrefixes,
                elfSuffixes: ruElfSuffixes,
                magicPrefixes: ruMagicPrefixes,
                magicSuffixes: ruMagicSuffixes,
                dragonPrefixes: ruDragonPrefixes,
                dragonSuffixes: ruDragonSuffixes,
            };
        case 'it':
            return {
                elfPrefixes: itElfPrefixes,
                elfSuffixes: itElfSuffixes,
                magicPrefixes: itMagicPrefixes,
                magicSuffixes: itMagicSuffixes,
                dragonPrefixes: itDragonPrefixes,
                dragonSuffixes: itDragonSuffixes,
            };
        case 'pl':
            return {
                elfPrefixes: plElfPrefixes,
                elfSuffixes: plElfSuffixes,
                magicPrefixes: plMagicPrefixes,
                magicSuffixes: plMagicSuffixes,
                dragonPrefixes: plDragonPrefixes,
                dragonSuffixes: plDragonSuffixes,
            };
        case 'nl':
            return {
                elfPrefixes: nlElfPrefixes,
                elfSuffixes: nlElfSuffixes,
                magicPrefixes: nlMagicPrefixes,
                magicSuffixes: nlMagicSuffixes,
                dragonPrefixes: nlDragonPrefixes,
                dragonSuffixes: nlDragonSuffixes,
            };
        case 'en':
        default:
            return {
                elfPrefixes: enElfPrefixes,
                elfSuffixes: enElfSuffixes,
                magicPrefixes: enMagicPrefixes,
                magicSuffixes: enMagicSuffixes,
                dragonPrefixes: enDragonPrefixes,
                dragonSuffixes: enDragonSuffixes,
            };
    }
};

export function generateFantasyNames(options: FantasyNameGeneratorOptions = {}): string[] {
    const count = options.count || 10;
    const style = options.style || 'any';
    const locale = options.locale || 'en';
    const names: string[] = [];

    const nameData = getFantasyNameData(locale);

    for (let i = 0; i < count; i++) {
        let currentStyle = style;
        if (currentStyle === 'any') {
            const styles = ['elf', 'magic', 'dragon'];
            currentStyle = styles[Math.floor(Math.random() * styles.length)] as 'elf' | 'magic' | 'dragon';
        }

        let prefix = '';
        let suffix = '';

        switch (currentStyle) {
            case 'elf':
                prefix = nameData.elfPrefixes[Math.floor(Math.random() * nameData.elfPrefixes.length)];
                suffix = nameData.elfSuffixes[Math.floor(Math.random() * nameData.elfSuffixes.length)];
                break;
            case 'magic':
                prefix = nameData.magicPrefixes[Math.floor(Math.random() * nameData.magicPrefixes.length)];
                suffix = nameData.magicSuffixes[Math.floor(Math.random() * nameData.magicSuffixes.length)];
                break;
            case 'dragon':
                prefix = nameData.dragonPrefixes[Math.floor(Math.random() * nameData.dragonPrefixes.length)];
                suffix = nameData.dragonSuffixes[Math.floor(Math.random() * nameData.dragonSuffixes.length)];
                break;
        }

        names.push(`${prefix}${suffix}`);
    }

    return names;
}
